class StickyProductForm extends HTMLElement {
  connectedCallback() {
    this.observeProductForm();
    this.productForm = this.closest('product-form');
    this.sectionId = this.productForm.dataset.sectionId;
  }

  disconnectedCallback() {
    this.unsubscribeVariantChanged();
    this.unsubscribeProductChanged();
  }

  /**
   * Observe the product form.
   */
  observeProductForm() {
    const productForm = document.querySelector('product-form');

    const observer = new IntersectionObserver(([{ isIntersecting }]) => {
      if (window.innerWidth <= 768) {
        if (isIntersecting) {
          this.querySelector('[data-sticky-add-to-cart-wrapper]').style.transform = '';
          this.classList.remove('has-sticky-atc');
        } else {
          this.classList.add('has-sticky-atc');
          this.querySelector('[data-sticky-add-to-cart-wrapper]').style.transform =
            'translateY(-7rem)';
        }
      }
    });

    observer.observe(productForm);
  }
}

customElements.define('sticky-add-to-cart', StickyProductForm);
